import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function QuestionnarieWithoutGene({ onAccept, showModal }) {
  const { t, i18n } = useTranslation();
  return (
    <Modal 
    show={showModal} 
    size="lg" 
    aria-labelledby="contained-modal-title-vcenter" 
    contentClassName="border-radius"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">{ t('patient_dashboard_up') }
        </Modal.Title>
      </Modal.Header> 
      <Modal.Body>
          
          <p>{ t('patient_dashboard_d3') }</p>
          
        {/* <p>This will send email to all the registered patient ....</p> */}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn bgc-primary text-light px-5" onClick={onAccept}>{ t('ok') }</button>
      </Modal.Footer>
    </Modal>
  );
}

export default QuestionnarieWithoutGene;